import { OnlyContentTypes } from 'govbr.frontend.policy/helpers/BlockConditions';
import { defineMessages } from 'react-intl';

import AreaInfoEdit from './AreaInfoEdit';
import AreaInfoView from './AreaInfoView';

import iconSVG from '@plone/volto/icons/info.svg';

defineMessages({
  areaInfoBlock: {
    id: 'Area information',
    defaultMessage: 'Area information',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.areaInfoBlock = {
    id: 'areaInfoBlock',
    title: 'Area information',
    group: 'organization',
    icon: iconSVG,
    view: AreaInfoView,
    edit: AreaInfoEdit,
    mostUsed: true,
    restricted: OnlyContentTypes(['Area']),
    sidebarTab: 0,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
